module.exports = __webpack_public_path__ + "img/aba_daag_yes.4081c067.png";